import { HttpMethod } from '@vision/ui/enums';
import { buildEndpointWithQuery } from '../utils/string.utils';

export interface GetSchemaFieldsV2Request {
  accountId: string;
  query?: string;
  type?: string;
  schemaType?: string;
}

export function buildGetSchemaFieldsV2Request({ accountId, query, type, schemaType }: GetSchemaFieldsV2Request) {
  return {
    url: buildEndpointWithQuery(
      `/v2/accounts/${accountId}/schema_fields`,
      [
        query,
        type ? `type=${encodeURIComponent(type)}` : '',
        schemaType ? `schema_type=${encodeURIComponent(schemaType)}` : '',
      ]
        .filter(Boolean)
        .join('&'),
    ),
    method: HttpMethod.GET,
  };
}
